import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, User, RefreshCw, HelpCircle } from 'lucide-react';
import axios from 'axios';
import { AdminLayout } from '../../components/AdminLayout';
import { useAdminTheme } from '../../contexts/AdminThemeContext';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL ? `${BACKEND_URL.replace(/\/$/, '')}/api` : '/api';

export const AdminSettings = () => {
  const navigate = useNavigate();
  const { theme } = useAdminTheme();

  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    if (!token) {
      navigate('/admin/login');
      return;
    }

    const fetchMe = async () => {
      try {
        const res = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });
        setMe(res.data);
      } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          navigate('/admin/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMe();
  }, [navigate, token]);

  const restartTour = () => {
    try {
      localStorage.removeItem('adminTourCompleted');
      localStorage.setItem('adminTourState', JSON.stringify({ open: true, index: 0 }));
    } catch {
      // ignore
    }
    navigate('/admin');
  };

  return (
    <AdminLayout title="Configurações" subtitle="Preferências e atalhos do painel">
      <div className="space-y-6">
        <Card className={`${theme.card} border rounded-2xl`}>
          <CardHeader>
            <CardTitle className={`${theme.text} flex items-center gap-2`}>
              <User className="h-5 w-5" />
              Conta
            </CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <div className={theme.textMuted}>Carregando...</div>
            ) : (
              <div className="space-y-2">
                <div className={theme.text}><strong>Email:</strong> {me?.email || '-'}</div>
                <div className={theme.text}><strong>Nome:</strong> {me?.name || '-'}</div>
                <div className={theme.text}><strong>Cargo:</strong> {me?.role || '-'}</div>
              </div>
            )}
          </CardContent>
        </Card>

        <Card className={`${theme.card} border rounded-2xl`}>
          <CardHeader>
            <CardTitle className={`${theme.text} flex items-center gap-2`}>
              <Settings className="h-5 w-5" />
              Ações
            </CardTitle>
          </CardHeader>
          <CardContent className="flex flex-col gap-3">
            <Button onClick={restartTour} className="justify-start bg-blue-600 hover:bg-blue-700">
              <HelpCircle className="h-4 w-4 mr-2" />
              Reiniciar tutorial (Ajuda)
            </Button>

            <Button
              variant="outline"
              onClick={() => navigate('/admin')}
              className="justify-start"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Voltar ao Dashboard
            </Button>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};
